import { useState, useEffect } from "react";
import { UnoStoreHooks, UiComponents, initializeConfig } from "@simulanisindia/ui";
import { applicationId, UNO_URL } from "./env";
import Layout from "./components/Layout/Layout";

const { useUnoSelector } = UnoStoreHooks;
const { FullScreenLoader } = UiComponents;

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
        initializeConfig({applicationId, authTokenKey:"token", UNO_URL:UNO_URL }).then(() =>  setLoading(false));

  }, []);

  return <>{loading ? <FullScreenLoader loading={loading} /> : <Layout />}</>;
};

export default App;
